/** Values of keyboard event key returned by event.key */
export enum KEY {
  ENTER = "Enter",
  ESC = "Escape",
  TAB = "Tab",
  SPACE = " ",
  BACKSPACE = "Backspace",
  UP_ARROW = "ArrowUp",
  DOWN_ARROW = "ArrowDown",
  LEFT_ARROW = "ArrowLeft",
  RIGHT_ARROW = "ArrowRight",

  QUOTE = "'",
  DOUBLE_QUOTE = '"',
  OPEN_BRACKET = "[",
  CLOSE_BRACKET = "]",
  LESS_THAN = "<",
  GREATER_THAN = ">",
  OPEN_PARENTHESIS = "(",
  CLOSE_PARENTHESIS = ")",
  OPEN_BRACE = "{",
  CLOSE_BRACE = "}",
  EQUAL = "=",

  PIPE = "|",
  DOT = ".",
  FORWARD_SLASH = "/",
  HYPHEN = "-",
  HASH = "#",

  k0 = "0",
  k1 = "1",
  k2 = "2",
  k3 = "3",
  k4 = "4",
  k5 = "5",
  k6 = "6",
  k7 = "7",
  k8 = "8",
  k9 = "9",

  A = "a",
  B = "b",
  C = "c",
  D = "d",
  E = "e",
  F = "f",
  G = "g",
  H = "h",
  I = "i",
  J = "j",
  K = "k",
  L = "l",
  M = "m",
  N = "n",
  O = "o",
  P = "p",
  Q = "q",
  R = "r",
  S = "s",
  T = "t",
  U = "u",
  V = "v",
  W = "w",
  X = "x",
  Y = "y",
  Z = "z",
}
